import { defineRouting } from 'next-intl/routing'

export const locales = ['en', 'fr'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale = 'en' as const
export const localePrefix = 'never'

export const routing = defineRouting({
    locales: locales,
    defaultLocale: 'en'
})
